import type { UploadResponse } from '@cult/schemas';
import { useMutation } from '@tanstack/react-query';
import { apiFetch } from '../../../lib/api-client';

export const uploadFile = (file: File): Promise<UploadResponse> => {
  const form = new FormData();
  form.append('file', file);
  return apiFetch<UploadResponse>('/uploads', { method: 'POST', body: form });
};

export const useUploadImage = () => {
  return useMutation({ mutationFn: uploadFile });
};
